const config = process.env.NODE_ENV !== "production" ? process.env : window.env;
export default config;
